import { InputCell } from './InputCell';

export default InputCell;
